import { CreditCard, Loader2, CheckCircle2, AlertTriangle } from "lucide-react";

function StatusMeta({ status }) {
  const state = status?.status || "trialing";
  if (state === "trialing") {
    return (
      <div className="mt-4 mono text-sm text-zinc-300">
        <div>
          Trial ends in{" "}
          <span className="neon-text">{status?.trial_days_left ?? 0} days</span>
        </div>
        <div className="text-xs text-zinc-500 mt-1">
          {status?.trial_ends_at ? new Date(status.trial_ends_at).toLocaleString() : ""}
        </div>
      </div>
    );
  }
  if (state === "active") {
    return (
      <div className="mt-4 mono text-sm text-zinc-300">
        <div>
          Week renews in{" "}
          <span className="neon-text">{status?.period_days_left ?? 0} days</span>
        </div>
        <div className="text-xs text-zinc-500 mt-1">
          {status?.subscription_period_end
            ? new Date(status.subscription_period_end).toLocaleString()
            : ""}
        </div>
      </div>
    );
  }
  return (
    <div className="mt-4 text-sm text-amber-300">
      Your access has expired. Renew for another week to unlock AI plays, arbitrage and the
      morning digest.
    </div>
  );
}

function checkoutLabel(state) {
  if (state === "active") return "Manage Subscription";
  if (state === "trialing") return "Start Paid Subscription";
  return "Subscribe · $9.99/wk";
}

export default function BillingStatusCard({
  status,
  checkoutLoading,
  onCheckout,
  onCancel,
  onRefresh,
}) {
  const state = status?.status || "trialing";
  const isActive = status?.is_active;

  return (
    <div
      data-testid="billing-status-card"
      className={`border p-6 ${
        isActive ? "border-[#00D4FF]/40 bg-[#00D4FF]/5" : "border-amber-500/40 bg-amber-500/5"
      }`}
    >
      <div className="overline flex items-center gap-2">
        {isActive ? (
          <CheckCircle2 size={14} strokeWidth={1.5} className="text-[#00D4FF]" />
        ) : (
          <AlertTriangle size={14} strokeWidth={1.5} className="text-amber-500" />
        )}
        CURRENT STATUS
      </div>
      <div
        className={`font-display text-4xl mt-3 uppercase ${isActive ? "neon-text" : "amber-text"}`}
        data-testid="billing-state"
      >
        {state}
      </div>

      <StatusMeta status={status} />

      <button
        onClick={onCheckout}
        disabled={checkoutLoading}
        data-testid="billing-checkout-button"
        className="mt-6 w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs hover:brightness-110 disabled:opacity-50"
      >
        {checkoutLoading ? (
          <Loader2 className="animate-spin" size={14} />
        ) : (
          <CreditCard size={14} strokeWidth={1.5} />
        )}
        {checkoutLabel(state)}
      </button>

      {state === "active" && (
        <div className="mt-3 flex flex-col gap-2">
          <button
            onClick={onCancel}
            data-testid="billing-cancel-button"
            className="text-xs mono uppercase tracking-widest text-zinc-400 hover:text-red-400"
          >
            Cancel auto-renewal
          </button>
          <button
            onClick={onRefresh}
            data-testid="billing-refresh-button"
            className="text-xs mono uppercase tracking-widest text-zinc-500 hover:text-[#00D4FF]"
          >
            Sync status with Stripe
          </button>
        </div>
      )}
    </div>
  );
}
